export const textTidy = (str: string) => {
    return str
        .replace(/[áàạảãâấầậẩẫăắằặẳẵäå]/g, 'a')
        .replace(/[ÁÀẠẢÃÂẤẦẬẨẪĂẮẰẶẲẴ]/g, 'A')
        .replace(/[đ]/g, 'd')
        .replace(/[Đ]/g, 'D')
        .replace(/æ/g, 'ae')
        .replace(/ç/g, 'c')
        .replace(/[éèẹẻẽêếềệểễë]/g, 'e')
        .replace(/[ÉÈẸẺẼÊẾỀỆỂỄ]/g, 'E')
        .replace(/[ìíîïịĩíỉ]/g, 'i')
        .replace(/[ÌÍĨỊỈ]/g, 'i')
        .replace(/ñ/g, 'n')
        .replace(/[óòọỏõôốồộổỗơớờợởỡö]/g, 'o')
        .replace(/[ÓÒỌỎÕÔỐỒỘỔỖƠỚỜỢỞỠ]/g, 'O')
        .replace(/œ/g, 'oe')
        .replace(/[úùụủũưứừựửữü]/g, 'u')
        .replace(/[ÚÙỤỦŨƯỨỪỰỬỮ]/g, 'U')
        .replace(/[ýỳỵỷỹÿ]/g, 'y')
        .replace(/[ÝỲỴỶỸ]/g, 'Y');
};

export const trim = (str = '') => {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};

export const normalize = (str = '') => {
    if (typeof str !== 'string') return '';
    return trim(str).replace(' ', '-');
};

export const numberWithCommas = (x: number) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export function escapeStringRegexp(string: string) {
    if (typeof string !== 'string') {
        return string;
    }
    let _string = trim(string);

    return _string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&').replace(/-/g, ' ');
}

export const formatSearchStr = (str: string) => {
    let _str = str.replace(/-/g, '_');
    _str = _str.replace(/ /g, '-');
    return encodeURIComponent(trim(_str));
};

export const formatQuerySearch = (str: string) => {
    let _keyword = str.replace(/-/g, ' ');
    _keyword = _keyword.replace(/_/g, '-');
    return _keyword;
};

export const countWord = (str: string) => {
    return trim(str).split(/\s+/).length;
}

export function stringify(value: any): string {
    try {
        return JSON.stringify(value);
    } catch (error) {
        return '';
    }
}

export function parse<T>(value: string): T | null {
    try {
        return JSON.parse(value) as T;
    } catch (error) {
        return null;
    }
}